// Services
import { HttpService } from "@mgs/ci2019-common/src/services/HttpService";

// Store
import { Store } from "#/store";

// Model
import { Userinfo } from "#/common/interfaces/auth/Userinfo";
import { UserinfoError } from "#/common/interfaces/auth/UserinfoError";

export class AuthService {
  private static _instance;

  public static get instance() {
    if (!this._instance) {
      this._instance = new AuthService();
    }
    return this._instance;
  }

  private constructor() {}

  private readonly http: HttpService = HttpService.instance;

  public async getUserinfo(
    redirectUrlAfterLogin: string,
    redirectUrlAfterLogout: string
  ): Promise<Userinfo | UserinfoError> {
    try {
      let queryUrl = Store.instance.ui.authApiUrl + `userinfo`;
      const response = await this.http.get<Userinfo>(queryUrl, {
        params: {
          redirect_url_after_login: redirectUrlAfterLogin,
          redirect_url_after_logout: redirectUrlAfterLogout,
        },
      });

      return response.body!;
    } catch (e: any) {
      if (e.status == 401) {
        return e.body!;
      } else {
        throw e;
      }
    }
  }

  public async oldUserInfo(language: string) {
    let queryUrl = "/portal/index.php";
    let params = {
      type: 200,
      id: 2,
      L: language,
      request_url: window.location.pathname,
      token: document.body.getAttribute("data-token"),
    };

    const response = await this.http.post<object>(queryUrl, undefined, {
      params: params,
    });

    return response.body!;
  }

  public async oldLogin(language: string, username: string, password: string) {
    let queryUrl = "/portal/index.php";
    let params = {
      type: 200,
      id: 2,
      L: language,
    };
    let data = new FormData();
    data.append("user", username);
    data.append("pass", password);
    data.append("token", document.body.getAttribute("data-token")!);
    data.append("logintype", "login");
    data.append("no_cache", "1");
    data.append("request_url", "");

    const response = await this.http.post<object>(queryUrl, data, {
      params: params,
    });

    return response.body!;
  }

  public async oldLogout(language: string) {
    let queryUrl = "/portal/index.php";
    let params = {
      type: 200,
      id: 2,
      logintype: "logout",
      request_url: window.location.href,
      L: language,
      token: document.body.getAttribute("data-token"),
    };

    const response = await this.http.post<object>(queryUrl, undefined, {
      params: params,
    });

    return response.body!;
  }

  public async updateTrackingStatus(trackingEnabled: boolean) {
    try {
      let queryUrl = Store.instance.ui.authApiUrl + `update_tracking_status`;
      const response = await this.http.post<Object>(queryUrl, {
        status: trackingEnabled,
      });

      return response.body!;
    } catch (e: any) {
      if (e.status == 403) {
        return e.body!;
      } else {
        throw e;
      }
    }
  }
}
